const AnnouncementBar = (function() {

  const instances = {};

  function copyToClipboard(text) {
    if (navigator.clipboard && window.isSecureContext) {
      return navigator.clipboard.writeText(text);
    }
    
    return new Promise((resolve, reject) => {
      const textArea = document.createElement('textarea');
      textArea.value = text;
      textArea.style.position = 'fixed';
      textArea.style.left = '-999999px';
      textArea.style.top = '-999999px';
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      
      try {
        const successful = document.execCommand('copy');
        textArea.remove();
        
        if (successful) {
          resolve();
        } else {
          reject(new Error('Copy command failed'));
        }
      } catch (err) {
        textArea.remove();
        reject(err);
      }
    });
  }

  /**
   * Banner Section Custom Element
   */
  class BannerSection extends HTMLElement {
    constructor(sectionId) {
      super();
      this.sectionId = sectionId;
      this.promoBox = null;
      this.timer = null;
      this.notification = null;
      this.timerInterval = null;
    }

    connectedCallback() {
      this.promoBox = this.querySelector(`.banner-${this.sectionId}__promo`);
      this.timer = this.querySelector(`.banner-${this.sectionId}__timer`);
      this.notification = this.querySelector(`.banner-${this.sectionId}__notification`);

      if (this.promoBox) {
        this.initPromoCode();
      }
      if (this.timer) {
        this.initTimer();
      }
    }

    disconnectedCallback() {
      if (this.timerInterval) {
        clearInterval(this.timerInterval);
      }
    }

    initPromoCode() {
      this.promoBox.addEventListener('click', (e) => {
        e.preventDefault();
        const code = this.promoBox.dataset.code;
        
        copyToClipboard(code)
          .then(() => {
            this.showNotification();
          })
          .catch((err) => {
            console.error('Failed to copy code:', err);
            // Still show notification as a fallback
            this.showNotification();
          });
      });
    }

    /**
     * Show success notification
     */
    showNotification() {
      if (!this.notification) return;
      
      this.notification.classList.add('active');
      setTimeout(() => {
        this.notification.classList.remove('active');
      }, 2000);
    }

    /**
     * Initialize countdown timer
     */
    initTimer() {
      const endDate = this.timer.dataset.endDate;
      const endTime = this.timer.dataset.endTime;

      if (!endDate || !endTime) return;

      const endDateTime = new Date(endDate + 'T' + endTime);

      const updateTimer = () => {
        const now = new Date();
        const timeLeft = endDateTime - now;

        if (timeLeft < 0) {
          clearInterval(this.timerInterval);
          this.timer.style.display = 'none';
          return;
        }

        // Create a date object from the remaining time
        const remainingTime = new Date(timeLeft);
        
        // Calculate time units more cleanly
        const days = Math.floor(timeLeft / (1000 * 60 * 60 * 24));
        const hours = remainingTime.getUTCHours();
        const minutes = remainingTime.getUTCMinutes();
        const seconds = remainingTime.getUTCSeconds();

        const daysEl = this.timer.querySelector(`[data-days] .banner-${this.sectionId}__timer-number`);
        const hoursEl = this.timer.querySelector('[data-hours]');
        const minutesEl = this.timer.querySelector('[data-minutes]');
        const secondsEl = this.timer.querySelector('[data-seconds]');

        if (daysEl) daysEl.textContent = String(days).padStart(2, '0');
        if (hoursEl) hoursEl.textContent = String(hours).padStart(2, '0');
        if (minutesEl) minutesEl.textContent = String(minutes).padStart(2, '0');
        if (secondsEl) secondsEl.textContent = String(seconds).padStart(2, '0');
      };

      updateTimer();
      this.timerInterval = setInterval(updateTimer, 1000);
    }
  }

  /**
   * Initialize a banner section
   */
  function init(sectionId) {
    if (instances[sectionId]) {
      return instances[sectionId];
    }

    const elementName = `banner-section-${sectionId}`;
    
    // Define custom element if not already defined
    if (!customElements.get(elementName)) {
      customElements.define(elementName, class extends BannerSection {
        constructor() {
          super(sectionId);
        }
      });
    }

    instances[sectionId] = true;
    return instances[sectionId];
  }

  return {
    init: init
  };
})();

if (typeof window !== 'undefined') {
  window.AnnouncementBar = AnnouncementBar;
}
